import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../service/order.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-customer-order-list',
  templateUrl: './customer-order-list.component.html',
  styleUrls: ['./customer-order-list.component.css']
})
export class CustomerOrderListComponent implements OnInit {

  orders: any[];
  cols = [
    { field: 'OrderNumber', header: 'מספר הזמנה', width: '160', priority: '' },
    { field: 'SupplierName', header: 'שם ספק', width: '200', priority: 'ui-p-1' },
    { field: 'OrderStatus', header: 'סטטוס', width: '100', priority: 'ui-p-2' },
    { field: 'OrderDate', header: 'תאריך הזמנה', width: '160', priority: 'ui-p-3' },
    { field: 'Destination', header: 'יעד', width: '80', priority: 'ui-p-6' },
    { field: 'DestinationName', header: 'תאור יעד', width: '180', priority: '' },
  ];
  colsLines = [
    { field: 'LineNumber', header: 'שורה', width: '50', priority: '' },
    { field: 'Catalog', header: 'מק"ט', width: '100', priority: 'ui-p-6' },
    { field: 'Description', header: 'תאור', width: '100', priority: '' },
    { field: 'Quantity', header: 'כמות', width: '100', priority: 'ui-p-2' },
    { field: 'UnitePrice', header: 'מחיר ליחידה', width: '100', priority: 'ui-p-5' },
    { field: 'Currency', header: 'מטבע', width: '100', priority: 'ui-p-6' },
    { field: 'DiscountPercent', header: '% הנחה', width: '100', priority: 'ui-p-6' },
    { field: 'Total', header: 'סה"כ לשורה', width: '100', priority: 'ui-p-5' },
    { field: 'QuantityReminder', header: 'יתרת כמות', width: '100', priority: 'ui-p-5' },
    { field: 'Balance', header: 'יתרה', width: '100', priority: '' }
  ];
  colsInvoices = [
    { field: 'InvoiceType', header: 'סוג', width: '80', priority: '' },
    { field: 'InvoiceNumber', header: 'מספר', width: '100', priority: 'ui-p-1' },
    { field: 'InvoiceDate', header: 'תאריך', width: '100', priority: 'ui-p-3' },
    { field: 'InvoiceStatus', header: 'סטטוס', width: '120', priority: 'ui-p-2' },
    { field: 'Notes', header: 'הערות', width: '120', priority: 'ui-p-2' },
    { field: 'Quantity', header: 'כמות', width: '100', priority: 'ui-p-4' },
    { field: 'UnitePrice', header: 'מחיר ליחידה', width: '100', priority: 'ui-p-5' },
    { field: 'Total', header: 'סה"כ לשורה', width: '100', priority: 'ui-p-3' },
    { field: 'TotalWithTax', header: 'כולל מע"מ', width: '100', priority: 'ui-p-4' }
  ];

  filterOrderNumber: any;
  //filterSupplier: any;
  filterOrderStatus: any;
  filterDateFrom: any;
  filterDateTo: any;

  //suppliersOptions: any[] = [];
  orderStatusOptions: any[] = [];

  msgs: Message[] = [];

  suppliers: any = [];
  selectedSuppliers: any = [];  //any[] = [];
  filteredSuppliers: any = [];  //any[] = [];

  showInvoicePreviewDialog: boolean = false;
  currentInvoiceDetails: any;

  constructor(private orderService: OrderService, private route: ActivatedRoute, private router: Router) { }

  searchSuppliers(event) {
    let query = event.query;
    this.filteredSuppliers = this.filterSuppliers(query, this.suppliers);
  }

  ngOnInit() {

    this.filterOrderNumber = null;

    //this.filterSupplier = null;
    this.selectedSuppliers = null;
    this.orderService.GetCustomerSuppliers().subscribe((result: any) => {
      //this.suppliersOptions = result;
      this.suppliers = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת ספקים ');
      });

    this.filterOrderStatus = null;
    this.orderService.GetCustomerOrderStatuses().subscribe((result: any) => {
      this.orderStatusOptions = result;
      // this.orderStatusOptions.unshift({ label: 'הכל', value: null });

    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת סטטוסים ');
      });



    let snapshot = this.route.snapshot;
    let invoiceId = snapshot.queryParamMap.get('o');
    //if (invoiceId == 'none') { invoiceId = null; }
    if (invoiceId == null || invoiceId == '') {
      let y = ((new Date()).getMonth() < 3) ? (new Date()).getFullYear() - 1 : (new Date()).getFullYear();
      //let fromD = new Date((new Date()).getFullYear(), 0, 1);
      let fromD = new Date(y, 0, 1);
      this.filterDateFrom = new Date(Date.UTC(fromD.getFullYear(), fromD.getMonth(), fromD.getDate()));
      this.filterDateTo = new Date();
    }


    this.getCustomerOrders();
  }

  getCustomerOrders() {
    let snapshot = this.route.snapshot;
    let invoiceId = snapshot.queryParamMap.get('o');
    //if (invoiceId == 'none') { invoiceId = null; }
    if (invoiceId != null && invoiceId != '') {
      this.filterOrderNumber = invoiceId;
      const params = { ...snapshot.queryParams };
      delete params.o;
      this.router.navigate([], { queryParams: params, replaceUrl: true });
    }
    // test         
    let orderFilter = {
      OrderNumber: this.filterOrderNumber,
      //SupplierId: this.filterSupplier ? this.filterSupplier.Id : null,
      SupplierId: this.selectedSuppliers ? this.selectedSuppliers.Id : null,
      OrderStatusId: this.filterOrderStatus,
      OrderDateFrom: this.filterDateFrom ? new Date(Date.UTC(this.filterDateFrom.getFullYear(), this.filterDateFrom.getMonth(), this.filterDateFrom.getDate())) : null,
      OrderDateTo: this.filterDateTo ? new Date(Date.UTC(this.filterDateTo.getFullYear(), this.filterDateTo.getMonth(), this.filterDateTo.getDate())) : null
    };
    this.orderService.getCustomerOrders(orderFilter).subscribe((result: any) => {
      this.orders = result;
    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  filterSuppliers(query, suppliers: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < suppliers.length; i++) {
      let supplier = suppliers[i];
      if (supplier.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 || supplier.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(supplier);
      }
    }
    return filtered;
  }

  showFile(invoice) {

    this.currentInvoiceDetails = invoice;
    this.showInvoicePreviewDialog = true;

  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/order/customer-order/customer-order-list/customer-order-list.component.ts